'use client'
import { useContext } from 'react'
import { ToastContext } from '@/context'

export const useToast = () => {
  const ctx = useContext(ToastContext)
  if (!ctx) throw new Error('useToast must be used within a ToastProvider')
  return ctx
}
